import { Observer } from 'mobx-react-lite';
import React from 'react';
import { ProjectMetaInfo } from '../../types/app.types';
import Line from '../Line/Line';
import ProjectEntry from '../ProjectEntry/ProjectEntry';
import './ProjectEntryList.scss';

type ProjectEntryListProps = {
  projects: ProjectMetaInfo[],
}

const ProjectEntryList = React.forwardRef<HTMLUListElement, React.PropsWithChildren<ProjectEntryListProps>>((props, ref) => {
  return <Observer children={() => (
    <ul className="ProjectEntryList" ref={ref}>
      {
        props.projects.map(project => <li
          key={project.name}
          className="ProjectEntryListItem"
        >
          <ProjectEntry project={project} />
          <Line />
        </li>)
      }
    </ul>
  )} />
})

export default ProjectEntryList;